$(document).ready(function() {
   $('.klaviyo-wrapper').each(function() {
     const that = $(this);
        $(this).find(".button-submit-klaviyo").click(function(event ) {
        event.preventDefault();
        that.find('form').addClass('active-loader');
        const email = that.find('.email-capture__input').val();
        const list_id = that.attr('data-listid');

        const options = {
          method: 'POST',
          headers: {revision: '2025-01-15', 'content-type': 'application/json'},
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Viair store newsletter form',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      location: {}
                    }
                  }
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: list_id
                  }
                }
              }
            }
          })
          
        };

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Wqz66K', options)
          //.then(response => response.json())
          .then(response => {
            console.log(response.status)
            if (response.status == 202){
              that.find(".success_message").show();
              that.find(".error_message").hide();
              that.find("input").removeClass('error_input');
            }else{
              that.find(".success_message").hide();
              that.find(".error_message").show().text('Error. Please try again.');
              that.find("input").addClass('error_input');
            }
            if (response.status == 400){
              that.find(".success_message").hide();
              that.find(".error_message").show().text('Please add a valid email.');
              that.find("input").addClass('error_input');
            }
          })
          .catch(err => console.error(err));
      });
    });
  });